<template>
  <div
    class="tariff-card"
    :class="{ primary }"
  >
    <h2 class="title">{{ title }}</h2>
    <div class="subtitle">{{ subtitle }}</div>
    <slot v-if="notEs" />
    <div class="btn-wrap">
      <CustomBtn @click="openDemoModal">{{ __('website.tariffs.cta.order_consultation') }}</CustomBtn>
    </div>
    <div class="footer-text">{{ footerText }}</div>
    <div
      v-if="discount && notEs"
      class="percentage"
    >-{{ discount }}%</div>
  </div>
</template>

<script>
import { openDemoModal } from '@/utils';
import CustomBtn from '@/components/CustomBtn';

export default {
  name: 'TariffCard',

  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    footerText: {
      type: String,
      default: '',
    },
    discount: {
      type: Number,
      default: 0,
    },
    primary: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    CustomBtn, 
  },

  computed: {
    notEs() {
      return this.$localization.lang !== 'es';
    },
  },

  methods: {
    openDemoModal,
  },
};
</script>

<style lang="sass" scoped>
.tariff-card
  text-align: center
  background: linear-gradient(200.24deg, #416076 2.98%, #3B4360 74.89%), #3B435F
  border-radius: 20px
  max-width: 324px
  position: relative
  margin: 0 8px
  &.primary
    max-width: 455px
    .title
      padding: 44px 0 8px
      font-size: 43px
      line-height: 60px
.title
  color: #fff
  font-weight: 700
  font-size: 30px
  line-height: 48px
  padding: 28px 0 10px
.subtitle
  max-width: 230px
  margin: 0 auto 32px
.btn-wrap
  padding: 0 20px
.subtitle,
.footer-text
  font-size: 14px
  line-height: 21px
  color: #BCC4D2
.footer-text
  margin: 24px 0 0
  padding: 24px 32px 0
  min-height: 137px
  border-top: 1px solid #5D637B
  text-align: left
.percentage
  position: absolute
  top: 8px
  right: 8px
  color: #fff
  background: #F98B25
  border-radius: 100px
  font-size: 16px
  line-height: 120%
  padding: 6px 12px
  font-weight: 600
  pointer-events: none

@media screen and (max-width: 1200px)
  .tariff-card
    max-width: 275px
    &.primary
      max-width: 386px
  .footer-text
    padding: 24px 20px 0

@media screen and (max-width: 999px)
  .tariff-card
    max-width: 100%
    margin: 32px 0 0
    &.primary
      max-width: 100%
      margin: 0
      .title
        font-size: 30px
        line-height: 48px
        padding: 28px 0 10px
  .footer-text
    padding: 24px
    min-height: auto
</style>